import { render, staticRenderFns } from "./shipping-quote-analise-hist-button.vue?vue&type=template&id=47522e04&lang=pug&"
import script from "./shipping-quote-analise-hist-button.vue?vue&type=script&lang=ts&"
export * from "./shipping-quote-analise-hist-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports